import { ComponentProps } from 'react';
import { cn } from 'utils/cn';

export function BoxNowrap({ className, ...props }: ComponentProps<'div'>) {
    return <div className={cn('whitespace-nowrap', className)} {...props} />;
}
